import { showSystemToast } from "./system_toast"
import { nativeHaptic } from "./native_bridge"

const CONFETTI_SRC = "https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js"

let loading = null
let cannon = null

export function ensureConfetti() {
    if (typeof window.confetti === "function") return Promise.resolve()
    if (loading) return loading
    loading = new Promise((resolve, reject) => {
        const script = document.createElement("script")
        script.src = CONFETTI_SRC
        script.async = true
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
    })
    loading.catch(() => {
        loading = null
    })
    return loading
}

function confettiCannon() {
    if (cannon) return cannon
    if (typeof window.confetti?.create !== "function") return null

    // The library's global fire function defaults to a blob-backed Web Worker.
    // Jane's CSP deliberately disallows blob workers, so that path creates a
    // canvas but never paints it. Keep the animation on the main thread instead.
    cannon = window.confetti.create(null, { resize: true, useWorker: false })
    return cannon
}

// One or more bursts from the shared cannon, for any surface that just wants
// confetti (a festive twin note on a public page). Quietly does nothing when
// the library can't load.
export function burstConfetti(bursts = [{}]) {
    ensureConfetti()
        .then(() => {
            const fire = confettiCannon()
            if (!fire) return
            bursts.forEach((options, i) => setTimeout(() => fire({ particleCount: 120, spread: 80, startVelocity: 45, ticks: 220, origin: { y: 0.6 }, ...options }), i * 180))
        })
        .catch(() => {})
}

// Daily task-completion confetti (Milestones::DailyTasks). The server returns a
// celebration only when today's count crosses a threshold, and it BURNS that
// threshold when it does — so every surface that completes a task has to render
// what came back. A surface that drops the payload doesn't just skip one burst,
// it eats the day's threshold and nothing fires again until the next tier.
// That is why this lives here rather than inside one controller.
export function celebrateDailyTasks(celebration) {
    if (!celebration) return
    const threshold = Number(celebration.threshold) || 10
    if (celebration.message) showSystemToast(celebration.message, { level: "success", duration: 4000 })
    nativeHaptic("medium")
    ensureConfetti()
        .then(() => {
            const fire = confettiCannon()
            if (!fire) return
            // More particles + more bursts as the bar climbs (10 → 1000).
            const tier = Math.min(6, Math.max(1, Math.round(Math.log10(threshold / 10) * 2) + 1))
            const particles = 120 + tier * 90
            const bursts = 1 + Math.floor(tier / 2)
            for (let i = 0; i < bursts; i++) {
                setTimeout(() => {
                    fire({ particleCount: particles, spread: 90 + tier * 15, startVelocity: 50, ticks: 250, origin: { y: 0.6 }, scalar: 1 + tier * 0.08 })
                }, i * 180)
            }
        })
        .catch(() => {})
}
